import { Link } from "react-router-dom";
import { HouseModernIcon } from "../components/icons";

// The signed-out global landing at `/`. No property context — that's
// only resolved inside `/:propertySlug/*` routes via PropertyProvider.
export default function Landing() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="max-w-md w-full text-center">
        <HouseModernIcon size={40} className="mx-auto text-slate-900" />
        <p className="mt-4 text-xs font-medium tracking-[0.2em] uppercase text-slate-500">
          maisons
        </p>
        <h1 className="mt-4 text-4xl font-semibold tracking-tight text-slate-900">
          Welcome home.
        </h1>
        <p className="mt-4 text-slate-600 leading-relaxed">
          Tenant portal for properties managed on maisons. Sign in to view
          your lease, track rent, submit requests, and keep up with what's
          going on.
        </p>
        <div className="mt-10 flex flex-col gap-3">
          <Link
            to="/sign-in"
            className="inline-flex items-center justify-center rounded-md bg-slate-900 px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-slate-800 transition-colors"
          >
            Sign in
          </Link>
          <Link
            to="/sign-up"
            className="text-sm text-slate-600 hover:text-slate-900 transition-colors"
          >
            New here? Sign up with your invite →
          </Link>
        </div>
      </div>
    </div>
  );
}
